"use strict";
// ATTENTION: DO NOT ADD REQUIRED() FLAG TO CLAIM SCHEMA
// Required fields are enforced at the end of claim-schema.ts `const submittedClaimSchema = claimSchema.options({ presence: 'required' });`
// This will ensure that all fields not explicitly marked as optional() are required
Object.defineProperty(exports, "__esModule", { value: true });
exports.partialPaymentSchema = void 0;
var constants_1 = require("@hobt/constants");
var utils_1 = require("@hobt/utils");
var Joi = require('joi').extend(require('@joi/date'));
exports.partialPaymentSchema = Joi.object({
    amount: Joi.number()
        .min(-9999999999999.99)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false }),
    comment: Joi.string()
        .min(1)
        .max(40)
        .optional()
        .allow(''),
    datePaid: Joi.date()
        .less(utils_1.getCurrentDate())
        .rule({
        message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_STRICTLY_PAST_DATE, 'Date Paid'),
    })
        .min(Joi.ref('/detail.dueDateOfLastCompleteInstallmentPaid'))
        .rule({
        message: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_PARTIAL_PAYMENTS_0),
    }),
});
exports.default = { partialPaymentSchema: exports.partialPaymentSchema };
